import React from "react";

const AugmentRRBase = () => {
  return (
    <div className="accordion-body">
      <div className="content">
        <div className="commitement-content">
          <p>
          We look at ways to expand our R&R base through targeted and disciplined exploration
          programmes. Our exploration teams aim to discover mineral and oil deposits in a safe
          and responsible way, to replenish the resources that support our future growth.
          </p>
        </div>

        <div className="commitement-content commitment-kits">
          <h5>KPIs</h5>
          <ul className="green-bullets">
            <li>Total 2P+2C R&R in O&G</li>
            <li>Total R&R in Zinc India and Zinc International</li>
          </ul>
        </div>

        <div className="commitement-content commitment-risks">
          <h5>Risks</h5>
          <ul className="green-bullets">
            <li>HSE</li>
            <li>Discovery risk</li>
          </ul>
          <ul className="green-bullets">
            <li>Regulatory and legal risk</li>
          </ul>
        </div>

        <div className="commitement-content commitment-risks">
          <h5>FY2020 Update</h5>
          <h6>Zinc India</h6>
          <ul className="green-bullets">
            <li>
              During the year, gross additions of 14.6 million tonnes were made to R&R, prior to depletion of 14.5 million tonnes
            </li>
            <li>Overall mine life continues to be more than 20 years</li>
          </ul>
          <ul className="green-bullets">
            <li>Combined R&R were estimated to be 403 million tonnes, containing 31.8 million tonnes of zinc-lead metal and 898 million ounces of silver</li>
          </ul>

          <h6>Zinc International</h6>
          <ul className="green-bullets">
            <li>
              During the year, gross additions of 75.4 million tonnes of ore and 4 million tonnes of metal were made to reserves and resources (R&R), after depletion
            </li>
            <li>The R&R support a mine life of more than three decades</li>
          </ul>
          <ul className="green-bullets">
            <li>Combined mineral resources and ore reserves estimated at 509.4 million tonnes, containing 26.6 million tonnes of metal</li>
          </ul>

          <h6>Oil & Gas</h6>
          <ul className="green-bullets">
            <li>
              Upside potential of ~5.5 billion boe of resource across a total of 51 blocks with the addition of 10 new blocks in OLAP II & III
            </li>
          </ul>
        </div>

      </div>
    </div>
  );
}

export default AugmentRRBase;